export const RecipeRunStatus = {
  Queued: 'queued',
  Running: 'running',
  Proposal: 'proposal',
  NothingToReview: 'nothing_to_review',
  Failed: 'failed',
} as const;

export type RecipeRunStatus =
  (typeof RecipeRunStatus)[keyof typeof RecipeRunStatus];

const FINISHED_STATUSES: ReadonlySet<RecipeRunStatus> = new Set<RecipeRunStatus>([
  RecipeRunStatus.Proposal,
  RecipeRunStatus.NothingToReview,
  RecipeRunStatus.Failed,
]);

export function isRunFinished(status: RecipeRunStatus): boolean {
  return FINISHED_STATUSES.has(status);
}

export interface RecipeRun {
  // `run_<32 hex>`, also the `triggerId` of the cards it proposes and of the hub's push.
  readonly id: string;
  readonly recipe: string;
  readonly recipeVersion: number | null;
  readonly status: RecipeRunStatus;
  readonly createdAt: string;
  readonly completedAt: string | null;
  readonly actionIds: readonly string[];
  readonly tokenUsage: Readonly<Record<string, unknown>> | null;
  // `message` is not for the reader: map `code` to your own text, an unknown one to a failure.
  readonly error: { readonly code: string; readonly message: string | null } | null;
}
